import { createConsumer } from '@rails/actioncable'

// ActionCable replacement for the Faye subscription (subscription.js). One per-account stream
// (MessagesChannel, scoped server-side to the logged-in account); payload.type routes to the same
// vm_messaging / vm_messaging_counter handlers Faye drove.
$(function () {
  // Only wire up where the messaging vars are present (nav badge is app-wide; /im adds the inbox VM).
  if (typeof messaging_account_channel === 'undefined' || !messaging_account_channel) return

  const updateGlobalUnreadCounter = function (count) {
    if (window.vm_messaging_counter && typeof count !== 'undefined') {
      window.vm_messaging_counter.unread = count
    }
  }

  const consumer = createConsumer() // connects to /cable (same origin)

  consumer.subscriptions.create('MessagesChannel', {
    received(data) {
      if (!data || !data.type) return

      switch (data.type) {
        case 'new':
          updateGlobalUnreadCounter(data.global_unread_count)
          if (window.vm_messaging) window.vm_messaging.messageReceived(data)
          break
        case 'mark_read':
          updateGlobalUnreadCounter(data.global_unread_count)
          if (window.vm_messaging) window.vm_messaging.markReadInUI(data.id)
          break
        case 'dialog_remove':
          if (window.vm_messaging) window.vm_messaging.removeDialog(data.id)
          break
        case 'message_remove':
          if (window.vm_messaging) {
            const msg = data.msg && data.msg.message ? data.msg.message : data.msg
            window.vm_messaging.removeMessageArrived(msg)
          }
          break
        // Twilio accepted or rejected an outgoing text AFTER the bubble was drawn (the send job runs
        // seconds behind the dealer's POST). Carries the message with its `send_error` set or cleared.
        case 'message_status':
          if (window.vm_messaging) window.vm_messaging.messageStatusArrived(data.message)
          break
        case 'flag':
          if (window.vm_messaging) window.vm_messaging.removeDialogByPhoneNumber(data.phone)
          if (window.vm_messaging_counter) window.vm_messaging_counter.requestUpdatedCount()
          break
      }
    }
  })
})
